import { Spinfinity, Typography } from '@repo/ui';

import styles from './HealthFormTransition.module.css';

export type HealthFormTransitionProps = {
  nextLabel: string;
  nextTimeEstimate?: string;
  nextDescription?: string;
};

export const HealthFormTransition = ({
  nextLabel,
  nextTimeEstimate,
  nextDescription,
}: HealthFormTransitionProps) => (
  <div className={styles.transition}>
    <Typography variant='heading-l'>
      {nextLabel}
      {nextTimeEstimate ? ` (~${nextTimeEstimate})` : ''}
    </Typography>
    {nextDescription && (
      <Typography variant='body-s' className='grey-text'>
        {nextDescription}
      </Typography>
    )}
    <div className={styles.loadingCard}>
      <Spinfinity size={24} />
      <Typography variant='body-s' className='grey-text'>
        Loading next form...
      </Typography>
    </div>
  </div>
);

export default HealthFormTransition;
